const windowTruncate = window && window.truncate || (() => { }); // See truncate.js

const truncateUtility = {
    truncate() {
        windowTruncate();
    }
}

export default truncateUtility;